import React from "react";

import { ListLeadsOrganisms } from "../../organisms";

export const ListLeadsPage: React.FC = () => {
  return <ListLeadsOrganisms />;
};
